export const GET_TABMENU = "GET_TABMENU ";
export const CHANGE_DRESSING = "CHANGE_DRESSING ";
